export default __webpack_public_path__ + "static/media/CorvoOutskirtsMap.1f4d0593.jpg";